const dummyReportData = {
    /* ================= COVER ================= */
    clientName: "SIMON ROBIN GORRINGE",
    reportingPeriod: "JUNE 2025",
    website: "www.demohanson.com",

    /* ================= REPORT SUMMARY ================= */
    reportSummary: `
    During June 2025, the SEO and PPC campaigns continued to deliver consistent
    performance improvements across multiple channels. Organic traffic showed
    stable growth driven by improved keyword rankings, content optimization, and
    local SEO enhancements.

    Paid campaigns generated strong conversion volume, particularly from high-intent
    search keywords. Overall, the combined SEO + PPC strategy resulted in increased
    visibility, improved user engagement, and higher order values compared to the
    previous month.
    `,

    /* ================= CHALLENGES ================= */
    challenges: `
    While overall performance remains positive, several challenges persist.
    High-competition keywords are experiencing ranking volatility due to aggressive
    competitor bidding and algorithm updates. Additionally, certain landing pages
    show lower-than-expected conversion rates, indicating the need for further CRO
    testing and UX optimization.

    Local SEO impressions increased; however, some locations show inconsistent
    engagement, which will be addressed in the upcoming month.
    `,

    /* ================= HIGHLIGHTS ================= */
    highlights: [
        "Increase/Decrease in eCommerce sales & conversions",
        "Traffic insights & trends",
        "Improvements in targeted location visits",
        "Top-performing and underperforming keywords",
        "Branding & engagement progress",
    ],

    /* ================= ORDERS PERFORMANCE ================= */
    ordersPerformance: {
        totalOrders: {
            title: "Total Orders",
            value: 142,
            subtitle: "+18% From last month",
            reason: "",
        },
        totalOrderValue: {
            title: "Total Order Value",
            value: "$12,430",
            subtitle: "+21% From last month",
            reason: "",
        },
        avgOrderValue: {
            title: "Avg Order Value",
            value: "$87",
            subtitle: "+6% From last month",
            reason: "",
        },
    },

    /* ================= CAMPAIGNS ================= */
    campaigns: [
        {
            name: "Google Search Ads",
            description: `
            This campaign focused on high-intent transactional keywords related to core
            products and services. Bid optimizations and improved ad copy resulted in
            higher click-through rates and improved Quality Scores.
                `,
            image: "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        },
        {
            name: "Display Remarketing",
            description: `
            Remarketing campaigns targeted previous website visitors with visually engaging
            display creatives. The strategy successfully increased brand recall and
            assisted conversions across the funnel.
                `,
            image: "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        },
        {
            name: "Shopping Ads",
            description: `
            Product-based shopping campaigns were optimized for top-performing SKUs.
            Improved feed quality and bid adjustments led to higher ROAS and order volume.
                `,
            image: "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        },
    ],

    /* ================= LOCAL SEO ================= */
    localSeoPerformance: [
        {
            name: "Google Business Profile – New York",
            interaction: 340,
            calls: 92,
            directions: 61,
            clicks: 130,
            image: "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        },
        {
            name: "Google Business Profile – Los Angeles",
            interaction: 210,
            calls: 55,
            directions: 38,
            clicks: 88,
            image: "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        },
    ],

    /* ================= KEYWORDS ================= */
    keywordSummary: `
    Keyword visibility improved notably throughout June, with multiple keywords
    entering the top 5 positions on Google. Continued content optimization and
    backlink acquisition contributed to steady ranking growth.

    The focus for the next month will be improving rankings for high-conversion,
    mid-funnel keywords and strengthening local keyword presence.
    `,

    keywords: [
        { keyword: "SEO Services", rank: 3 },
        { keyword: "Digital Marketing Agency", rank: 5 },
        { keyword: "Search Engine Optimization", rank: 4 },
        { keyword: "Local SEO Services", rank: 2 },
        { keyword: "Google Business Profile Optimization", rank: 6 },
        { keyword: "Ecommerce SEO", rank: 7 },
        { keyword: "PPC Management Services", rank: 4 },
        { keyword: "Online Marketing Agency", rank: 8 },
    ],

    /* ================= TRAFFIC COMPARISON ================= */
    performanceComparison: [
        {
            metric: "Total Website Visits",
            current: 1430,
            last: 1210,
            percentage: "+18%",
            trend: "up",
        },
        {
            metric: "Organic Traffic",
            current: 870,
            last: 720,
            percentage: "+21%",
            trend: "up",
        },
        {
            metric: "Direct Traffic",
            current: 310,
            last: 260,
            percentage: "+19%",
            trend: "up",
        },
        {
            metric: "Referral Traffic",
            current: 250,
            last: 280,
            percentage: "-11%",
            trend: "down",
        },
        {
            metric: "Paid Traffic",
            current: 460,
            last: 620,
            percentage: "-26%",
            trend: "down",
        },
    ],

    /* ================= NEXT STEPS ================= */
    nextSteps: `
    In the upcoming month, focus will be placed on improving conversion rates through
    landing page optimization and A/B testing. SEO efforts will prioritize content
    expansion around high-performing keywords and strengthening internal linking.

    PPC strategies will include bid refinement, creative testing, and scaling
    high-performing campaigns. Local SEO improvements will target underperforming
    locations to ensure consistent engagement across all regions.
    `,

    /* ================= CHART IMAGES ================= */
    charts: {
        orders:
            "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
        keywords:
            "https://seoprofy.com/wp-content/uploads/2024/09/3-seo-results.jpg",
    },
}







export const dummyContent = `<p>&nbsp;<strong>PRIVATE &amp; CONFIDENTIAL</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Date: 20/09/2025&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Name:</strong>&nbsp;&nbsp;</p>
<p><strong>Address:</strong> G-50, Life Style, Waghodiya Road, Vadodara – 390025, Gujarat, India&nbsp;</p>
<p>&nbsp;</p>
<p>Dear {Name of Candidate},&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Offer of Employment</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>We are pleased to offer you the position of <strong>Junior Business Analyst</strong> with <strong>Zithas Technologies Pvt. Ltd.</strong>, on the following terms and conditions.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>1. Commencement Date</strong>&nbsp;</p>
<p>Your employment is scheduled to commence on <strong>01/01/2026</strong>, or on a date mutually agreed in writing.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>2. Compensation</strong>&nbsp;</p>
<p>Your stipend will be <strong>INR 0 per month</strong>, payable monthly in accordance with Company payroll policies.&nbsp;</p>
<p>A detailed salary structure will be shared in your Appointment Letter (Annexure B).&nbsp;</p>
<p>&nbsp;</p>
<p>Your compensation will be reviewed periodically as per Company policy.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>3. Variable Performance Incentive</strong>&nbsp;</p>
<p>You may be eligible for a <strong>Performance-Based Incentive</strong>, awarded based on work performance, attendance, punctuality, and overall conduct.&nbsp;</p>
<p>Further details will be specified in your Appointment Letter.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>4. Payment Method</strong>&nbsp;</p>
<p>Your salary will be paid in India into your nominated bank account after applicable deductions as per Company policy and Indian laws.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>5. Benefits</strong>&nbsp;</p>
<p>You will be eligible for Company-provided benefits in accordance with Zithas policies, which currently include paid leave, medical leave, and company-declared public holidays, along with any additional benefits that the Company may introduce from time to time.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>6. Contract of Employment</strong>&nbsp;</p>
<p>Your <strong>Appointment Letter</strong>, containing detailed employment terms and conditions, will be issued upon joining and will form an integral part of this offer.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>7. Preconditions for Employment</strong>&nbsp;</p>
<p>This offer of employment is subject to the successful completion of background and reference verification, submission of all required documents, and providing a relieving letter from your previous employer. You may also be required to undergo a medical fitness assessment if deemed necessary for the role. The formal Contract of Employment will be issued only upon satisfactory fulfilment of these pre-employment conditions.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>8. Jurisdiction</strong>&nbsp;</p>
<p>Any disputes arising out of this offer or your employment shall be governed by the laws of India and subject to the jurisdiction of the competent courts.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Yours sincerely,</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>______________________________</strong>&nbsp;</p>
<p><strong>Yesha Makwana</strong>&nbsp;<br>&nbsp;</p>
<p><strong>OPERATIONS DIRECTOR</strong>&nbsp;</p>
<p>Zithas Technologies Pvt. Ltd.&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Employment Offer Acceptance</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>I accept your offer of employment and agree to be bound by the terms and conditions contained in this Offer Letter and the forthcoming Appointment Letter.&nbsp;</p>
<p>&nbsp;</p>
<p>Signed: ………………………………………….&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Date : ……………………….&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>Name:&nbsp;&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>I am accepting offer from &nbsp;………………………………………&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>CONTRACT OF SERVICE</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Written Statement of Main Terms and Conditions of Employment.</strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Name &amp; Address of Employer:</strong> &nbsp;</p>
<p>&nbsp;</p>
<p>Zithas Technologies Pvt. Ltd whose office is situated at FF-16, Kalpvrux Complex, Opp. GEB Substation, Gotri, Vadodara - 390021, Gujarat, India (the “Employer”).&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Name &amp; Address of Employee:</strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>{Candidate Name} </strong>(Aadhar No. {No})&nbsp;</p>
<p>G-50, Life Style, Waghodiya Road, Vadodara – 390025, Gujarat, India&nbsp;</p>
<p>(the “Employee”).&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Main Terms and Conditions of your Employment</strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>1. Commencement of Employment</strong>&nbsp;</p>
<p>Your employment with <strong>Zithas Technologies Pvt. Ltd.</strong> (“the Company”) shall commence on <strong>01/01/2026</strong> (“Commencement Date”). Your period of continuous service shall be calculated from this date. No employment with any previous employer shall count towards your continuous service with the Company.&nbsp;</p>
<p>This appointment is subject to the following conditions being fully satisfied:&nbsp;</p>
<p><strong>a) Background Verification</strong>&nbsp;</p>
<p>Successful completion of all background and reference checks, including verification of identity, education, employment history, and any other checks deemed necessary by the Company.&nbsp;</p>
<p><strong>b) Submission of Required Documents</strong>&nbsp;</p>
<p>Timely submission of all documents requested by the Company, including educational certificates, identity proofs, and relieving letters from previous employers.&nbsp;</p>
<p><strong>c) Medical Fitness Requirement</strong>&nbsp;</p>
<p>The Employee confirms that they are medically fit to perform the duties and responsibilities of the position at the time of joining.&nbsp;</p>
<p>The Company reserves the right to require a medical examination by a Company-appointed practitioner at any time during employment if deemed necessary.&nbsp;</p>
<p>Any medical condition – existing or arising during the course of employment – that materially affects performance, attendance, or the ability to carry out assigned duties must be disclosed immediately with genuine medical documentation.&nbsp;</p>
<p>A claim of medical incapacity <strong>shall not:</strong>&nbsp;</p>
<p>waive, reduce, or override the contractual notice period;&nbsp;</p>
<p>entitle the Employee to immediate relieving; or&nbsp;</p>
<p>restrict the Company’s right to take employment action, including termination with notice, in accordance with this Agreement.&nbsp;</p>
<p>If the Employee is unable to perform essential duties for an extended duration due to medical reasons, the Company may reassign duties or take further action based on operational needs.&nbsp;</p>
<p><strong>d) Accuracy of Information</strong>&nbsp;</p>
<p>If any information or document provided by the Employee is found to be false, misleading, or incomplete, the Company reserves the right to withdraw this appointment or terminate employment <strong>with immediate effect</strong>, without notice or compensation.&nbsp;</p>
<p><strong>2. Position &amp; Location</strong>&nbsp;</p>
<p>You are appointed as <strong>Junior</strong> <strong>Business Analyst</strong> with <strong>Zithas Technologies Pvt. Ltd.</strong> (“the Company”). You will report to your assigned Team Lead or Manager, or any other person the Company may designate based on business requirements.&nbsp;</p>
<p>Your primary place of work will be:&nbsp;</p>
<p><strong>FF-16, Kalpvrux Complex, Opp. GEB Substation, Gotri, Vadodara – 390021</strong>&nbsp;</p>
<p>Your standard office working hours are:&nbsp;</p>
<p><strong>9:00 AM to 6:30 PM, Monday to Saturday </strong>(1st and 3rd Saturdays are holidays)&nbsp;</p>
<p>You may be required to remain beyond standard working hours on days when project deadlines or business needs require additional attention. This is a normal expectation in the software and IT services industry.&nbsp;</p>
<p>From time to time, and depending on project assignments, you may be required to work from:&nbsp;</p>
<p>Other Company office locations, or&nbsp;</p>
<p>Client locations within India, or&nbsp;</p>
<p>A remote work location (Work From Home), if approved by the Company.&nbsp;</p>
<p>Any such change in work location will be reasonable and in line with the Company’s operational requirements. At all times, you must comply with Company policies and confidentiality obligations, regardless of where you work.&nbsp;</p>
<p>The Company also retains the discretion to reassign your team, reporting manager, or project as necessary based on business and operational needs.&nbsp;</p>
<p><strong>3. Salary &amp; Remuneration</strong>&nbsp;</p>
<p>Your salary and compensation details are set out in <strong>Annexure B</strong> of this Appointment Letter. Your salary will be paid on a monthly basis to your designated salary bank account, in accordance with the Company’s payroll schedule and prevailing policies.&nbsp;</p>
<p>All salary payments will be made <strong>after applicable statutory deductions</strong>, including Professional Tax and any additional statutory deductions such as Provident Fund (PF) and Employee State Insurance (ESIC), if and when they become applicable under Indian law.&nbsp;</p>
<p>&nbsp;</p>
<p>Your salary structure may include components such as Basic Salary, House Rent Allowance (HRA), Dearness Allowance, Conveyance or any other allowances or benefits as determined by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>Any future changes to compensation, including salary revisions, increments, or bonuses, shall be at the sole discretion of the Company and based on your performance, conduct, business conditions, and Company policies.&nbsp;</p>
<p>&nbsp;</p>
<p>The Company reserves the right to modify salary components to comply with applicable laws, taxation requirements, or statutory guidelines, without reducing your total fixed gross compensation unless mandated by law or mutually agreed in writing.&nbsp;</p>
<p><strong>4. Probationary Period</strong>&nbsp;</p>
<p>You will be on <strong>probation for a period of three (3) months</strong> from your Date of Joining. During the probation period, your performance, conduct, attendance, learning curve, and overall suitability for the role will be evaluated by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>The Company may, at its discretion:&nbsp;</p>
<p>confirm your employment upon successful completion of probation,&nbsp;</p>
<p>extend your probation period if performance or conduct requires further evaluation, or&nbsp;</p>
<p>terminate your employment during probation with written notice as per Company policy.&nbsp;</p>
<p>&nbsp;</p>
<p>Unless expressly confirmed in writing, continuation of employment beyond the probation period <strong>shall not be construed as confirmation</strong> of employment. Confirmation is strictly subject to satisfactory performance and managerial approval.&nbsp;</p>
<p>Upon confirmation, you will continue under the remaining terms of this Appointment Letter and the Company’s applicable policies.&nbsp;</p>
<p><strong>5. Working Hours</strong>&nbsp;</p>
<p>Your standard working hours shall be <strong>9:00 AM to 6:30 PM</strong>, Monday to Saturday, with a lunch break as per Company policy. The <strong>1st and 3rd Saturdays</strong> of every month will be observed as non-working days.&nbsp;</p>
<p>The nature of the software development and IT services industry may occasionally require you to work beyond standard hours to meet project deadlines, client requirements, or operational needs. In such situations, you are expected to extend your working hours to ensure completion of assigned tasks and deliverables.&nbsp;</p>
<p>Extended working hours shall not be considered overtime unless specifically approved in writing by the Management.&nbsp;</p>
<p>All employees are required to maintain punctuality and adhere to attendance procedures prescribed by the Company.&nbsp;</p>
<p>You may also be required to work in alternate shifts or rotational schedules on rare occasions, depending on project or operational demands. Any such changes will be communicated in advance and kept within reasonable limits.&nbsp;</p>
<p><strong>6. Leave &amp; Holidays</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>You will be entitled to leave in accordance with the Company’s Leave Policy, as amended from time to time. Your leave eligibility under the current policy is as follows:&nbsp;</p>
<p>&nbsp;</p>
<p><strong>a) Earned Leave (EL)</strong>&nbsp;</p>
<p>You shall accrue 1 (one) day of Earned Leave per month, subject to a maximum accumulation limit of 24 days. A maximum of 3 Earned Leaves may be availed in a month. Earned Leave may be encashed as per Company policy upon reaching the prescribed limit.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>b) Sick Leave (SL)</strong>&nbsp;</p>
<p>You shall be entitled to 1 (one) day of Sick Leave per month, subject to a maximum accumulation limit of 18 days. Sick Leave must be used strictly for genuine illness. Medical certification may be required for consecutive leave as per Company policy.&nbsp;</p>
<p><strong>c) Public Holidays</strong>&nbsp;</p>
<p>You are entitled to Company-declared public holidays. A holiday list shall be communicated at the beginning of each calendar year.&nbsp;</p>
<p><strong>d) Leave Application &amp; Approval</strong>&nbsp;</p>
<p>All leave must be applied through the designated Company system and approved in advance. Applying for leave does not constitute approval, and employees must ensure that leave is approved before proceeding. Any absence without approval shall be treated as unauthorized leave.&nbsp;</p>
<p><strong>e) Leave Without Pay (LWP)</strong>&nbsp;</p>
<p>If leave balance is exhausted, any approved leave shall be treated as Leave Without Pay (LWP), subject to prior approval from Management and HR.&nbsp;</p>
<p><strong>f) Unapproved Absence &amp; Disciplinary Action</strong>&nbsp;</p>
<p>Unapproved or uninformed absence may result in Leave Without Pay (LWP), salary deductions, and disciplinary action. Repeated violations may be treated as misconduct under Clause 20.&nbsp;</p>
<p><strong>g) Encashment &amp; Limits</strong>&nbsp;</p>
<p>Leave encashment, accumulation limits, and related conditions shall be governed strictly as per the Company’s Leave Policy.&nbsp;</p>
<p><strong>Leave shall be governed as per the Company’s Leave Policy, as amended from time to time.</strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>7. Performance Incentive</strong>&nbsp;</p>
<p>You may be eligible for performance-based incentives as per the Company’s policies. Eligibility and pay-out of incentives shall depend on factors such as work performance, behaviour, attendance, adherence to deadlines, compliance with Company policies, and the overall business performance of the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>Performance incentives are <strong>not guaranteed</strong> and are paid <strong>solely at the discretion of the Company</strong>. The Company reserves the right to introduce, modify, suspend, or withdraw any incentive program at any time.&nbsp;</p>
<p>&nbsp;</p>
<p>No incentive shall be considered as part of the Employee’s fixed compensation, nor shall it form a basis for any future claim, expectation, or continuity of benefit.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>8. Employment Contract Duration, Resignation &amp; Notice Period</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Your employment with the Company shall be governed by a fixed-term contractual engagement of <strong>two (2) years</strong> commencing from your Date of Joining (“Contract Period”). Upon completion of this period, your employment shall continue automatically unless terminated by either party in accordance with this Clause.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>a) Resignation by the Employee</strong>&nbsp;</p>
<p>If you wish to resign from your employment at any time during or after the Contract Period, you are required to serve a <strong>four (4) months’ written notice</strong> to the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>The notice period is mandatory and is intended to ensure continuity of operations, smooth handover of responsibilities, and proper knowledge transfer.&nbsp;</p>
<p>&nbsp;</p>
<p>The Company is <strong>not obligated to accept requests for early relieving</strong>. Relieving documents, experience letters, and full &amp; final settlement will be processed only after:&nbsp;</p>
<p>successful completion of the full notice period,&nbsp;</p>
<p>completion of all assigned tasks,&nbsp;</p>
<p>satisfactory handover,&nbsp;</p>
<p>return and clearance of Company assets, and&nbsp;</p>
<p>submission of required documentation.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>b) Withdrawal or Short Notice</strong>&nbsp;</p>
<p>If the Employee resigns without serving the full notice period, the Company reserves the right to:&nbsp;</p>
<p>decline early relieving,&nbsp;</p>
<p>delay or withhold relieving and experience letters, and&nbsp;</p>
<p>delay or withhold final settlement until full handover is completed.&nbsp;</p>
<p>&nbsp;</p>
<p>No salary, benefits, or incentives shall be payable for any unserved portion of the notice period unless explicitly approved in writing by Management.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>c) Notice During Probation</strong>&nbsp;</p>
<p>During probation, employment may be terminated by either party with written notice as per Company policy.&nbsp;</p>
<p>The Company may terminate employment during probation for unsatisfactory performance, conduct issues, or operational requirements.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>d) Completion of Contract Period</strong>&nbsp;</p>
<p>Upon completion of the two-year Contract Period, this Appointment Letter and all terms herein shall continue to remain in force unless revised or terminated in writing by either party.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>e) Immediate Resignation Not Permitted</strong>&nbsp;</p>
<p>Medical grounds, personal issues, family concerns, or relocation <strong>shall not</strong> be considered valid reasons to waive or shorten the contractual notice period unless approved at the sole discretion of the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>f) Company’s Right to Immediate Termination</strong>&nbsp;<br>This clause does not affect the Company’s right to terminate employment <strong>with immediate effect</strong> in the event of misconduct, breach of confidentiality, violation of Company policies, or any act prejudicial to the interests of the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>9. Termination by the Company</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Company reserves the right to terminate your employment under the following conditions:&nbsp;</p>
<p>&nbsp;</p>
<p><strong>a) Termination With Notice</strong>&nbsp;</p>
<p>The Company may terminate your employment by providing <strong>four (4) months’ written notice</strong>, or salary in lieu of notice, at its discretion. The Company may also place you on Garden Leave during the notice period.&nbsp;</p>
<p>&nbsp;</p>
<p>During the notice period, you are required to:&nbsp;</p>
<p>continue performing your duties with professionalism,&nbsp;</p>
<p>comply with all Company policies,&nbsp;</p>
<p>complete handover tasks,&nbsp;</p>
<p>return Company property, and&nbsp;</p>
<p>support knowledge transfer and transition activities.&nbsp;</p>
<p>&nbsp;</p>
<p>Failure to cooperate during the notice period may result in disciplinary action, withholding of relieving documents, or withholding of final settlement until compliance is ensured.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>b) Termination During Probation</strong>&nbsp;</p>
<p>During the probation period, your employment may be terminated by the Company with written notice as per Company policy. The Company may terminate your employment immediately during probation for unsatisfactory performance, poor conduct, or failure to meet expectations.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>c) Termination Without Notice (Summary Termination)</strong>&nbsp;</p>
<p>The Company may terminate your employment <strong>with immediate effect and without notice</strong> for reasons including, but not limited to:&nbsp;</p>
<p>misconduct, misbehaviour, or insubordination;&nbsp;</p>
<p>breach of confidentiality or data protection obligations;&nbsp;</p>
<p>violation of Company policies or Code of Conduct;&nbsp;</p>
<p>falsification of documents, misrepresentation, or fraud;&nbsp;</p>
<p>gross negligence or willful disobedience;&nbsp;</p>
<p>unauthorised absence or abandonment of employment;&nbsp;</p>
<p>theft, misuse, or unauthorised disclosure of Company or client assets;&nbsp;</p>
<p>any act detrimental to the interests, reputation, or security of the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>In such cases, the Company has no obligation to provide relieving letters, experience letters, or compensation in lieu of notice.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>d) Abandonment of Employment</strong>&nbsp;</p>
<p>If you remain absent from work for <strong>three (3) consecutive working days</strong> without approval or valid justification, the Company may treat such absence as <strong>voluntary abandonment of employment</strong>, in which case your employment may be terminated with immediate effect.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>e) Effect of Termination</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Upon termination for any reason, you must:&nbsp;</p>
<p>immediately cease representing the Company,&nbsp;</p>
<p>return all Company assets, equipment, data, and intellectual property,&nbsp;</p>
<p>clear outstanding obligations, and&nbsp;</p>
<p>complete the formal exit process.&nbsp;</p>
<p>&nbsp;</p>
<p>Relieving documents and final settlement will be issued only after satisfactory completion of all exit formalities.&nbsp;</p>
<p><strong>10. Applicability of Company Policies</strong>&nbsp;</p>
<p>All your duties, responsibilities, conduct, behaviour, and employment-related matters shall be governed by the Company’s policies, procedures, handbooks, and guidelines as issued or amended by the Company from time to time. You agree to comply with all such policies, including but not limited to HR policies, IT and security policies, leave and attendance rules, workplace conduct policies, and any other guidelines communicated by the Company.&nbsp;</p>
<p>The Company reserves the right to modify, withdraw, or introduce any policy at its discretion. Any such changes shall become effective upon communication and shall automatically apply to your employment without the need to amend this Appointment Letter.&nbsp;</p>
<p><strong>11. Certificate Holding (Education Documents)</strong>&nbsp;</p>
<p>For verification and record purposes, the Employee agrees to submit original educational certificates and relevant documents at the time of joining. The Company shall securely retain such documents and return them upon separation or at the time of full and final settlement. These documents will not be used for any purpose other than employment verification. The Employee confirms that all documents submitted are authentic, and understands that submission of forged, altered, or misleading documents may result in immediate termination without notice.&nbsp;</p>
<p><strong>12. Training &amp; Development</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Company may, at its discretion, provide you with training, skill-development programs, onboarding sessions, or any other learning initiatives relevant to your role. Participation in such programs may be mandatory based on business requirements.&nbsp;</p>
<p>&nbsp;</p>
<p>All training materials, documents, software, and content provided during such programs shall remain the exclusive property of the Company and must not be shared, disclosed, or reproduced without prior written approval.&nbsp;</p>
<p>&nbsp;</p>
<p>The cost of any specialized training, certification, or external program sponsored by the Company may be recoverable if the Employee resigns within a stipulated period as defined under Company policy or in the specific training agreement, if applicable.&nbsp;</p>
<p>The Company reserves the right to modify, introduce, or withdraw training programs at any time based on operational and organizational needs.&nbsp;</p>
<p><strong>13. Duties &amp; Responsibilities</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>You shall diligently perform the duties of a <strong>Business Analyst</strong> and any other responsibilities reasonably assigned to you by the Company. Your duties may evolve based on project requirements, business needs, and managerial direction. Key responsibilities include, but are not limited to, the following:&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Project &amp; Requirement Analysis</strong>&nbsp;</p>
<p>Understanding, documenting, and analysing client requirements.&nbsp;</p>
<p>Preparing business requirement documents, user stories, process flows, and functional specifications.&nbsp;</p>
<p>Coordinating with development, design, QA, and other teams to ensure clarity and alignment of requirements.&nbsp;<br>&nbsp;</p>
<p><strong>Client Communication &amp; Meeting Documentation</strong>&nbsp;</p>
<p>Conducting meetings, presentations, and discussions with clients as required.&nbsp;</p>
<p>Maintaining proper written records of all client discussions, decisions, and action points.&nbsp;</p>
<p>Uploading meeting notes, call summaries, requirement updates, and related documentation to the Company’s designated systems (such as project management tools, CRM, or shared drives) on a timely basis.&nbsp;</p>
<p>Ensuring transparency, completeness, and traceability in all client communications.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Task &amp; Delivery Management</strong>&nbsp;</p>
<p>Ensuring timely delivery of assigned tasks.&nbsp;</p>
<p>Coordinating with internal teams to track progress and resolve blockers.&nbsp;</p>
<p>Maintaining structured project documents and updating the status in Company systems.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Quality &amp; Compliance Responsibilities</strong>&nbsp;</p>
<p>Ensuring deliverables meet standards of accuracy, clarity, and quality.&nbsp;</p>
<p>Adhering to Company policies, project workflows, documentation formats, and client communication guidelines.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Confidentiality &amp; Information Handling</strong>&nbsp;</p>
<p>Handling all client and Company information with strict confidentiality.&nbsp;</p>
<p>Ensuring secure usage, storage, and transfer of documents and data as per Company policy.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Professional Conduct</strong>&nbsp;</p>
<p>Maintaining professionalism in all interactions with clients, team members, and management.&nbsp;</p>
<p>Demonstrating discipline, punctuality, cooperation, and a positive work attitude.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Flexibility &amp; Additional Duties</strong>&nbsp;</p>
<p>Performing any additional responsibilities or tasks assigned by your reporting manager or management, in line with business and operational needs.&nbsp;</p>
<p>Adapting to changing requirements in a dynamic IT environment.&nbsp;</p>
<p>&nbsp;</p>
<p>Failure to perform duties, maintain documentation, or comply with Company protocols may result in corrective measures or disciplinary action under Clause 20 of this Agreement.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>14. Company Property</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>All equipment, documents, files, data, software, devices, or any other property provided to you by the Company (“Company Property”) shall always remain the exclusive property of the Company. You are responsible for the proper use, safety, and maintenance of such property during the course of your employment.&nbsp;</p>
<p>&nbsp;</p>
<p>Upon resignation or termination, you must return all Company Property in good working condition, including but not limited to laptops, chargers, peripherals, project documents, source code, access credentials, and any other technical or operational material belonging to the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>The Company may withhold relieving documents, experience letters, or final settlements until all Company Property has been returned and all clearances have been completed.&nbsp;</p>
<p>&nbsp;</p>
<p><i>For clarity, Company-issued access cards may be retained by the Employee as a keepsake and are not required to be returned.</i>&nbsp;</p>
<p>Unauthorized use, loss, misuse, tampering, or sharing of Company Property shall be treated as misconduct and may result in disciplinary action.&nbsp;</p>
<p><strong>15. Confidentiality</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>During your employment with <strong>Zithas Technologies Pvt. Ltd.</strong> (“the Company”) and thereafter, you shall maintain strict confidentiality of all information that comes to your knowledge in the course of your work. Confidential information includes, but is not limited to:&nbsp;</p>
<p>Client information, project requirements, documentation, and deliverables&nbsp;</p>
<p>Source code, scripts, algorithms, databases, and system architecture&nbsp;</p>
<p>Proprietary tools, methodologies, templates, and internal processes&nbsp;</p>
<p>Business plans, marketing strategies, pricing details, and financial data&nbsp;</p>
<p>Employee information, HR records, internal communication, and operational data&nbsp;</p>
<p>Login credentials, access rights, passwords, and any system-related information&nbsp;</p>
<p>Any other data or material designated as confidential by the Company or its clients&nbsp;</p>
<p>&nbsp;</p>
<p>You agree that:&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Use Limitation</strong>&nbsp;<br>Confidential information shall be used strictly for the purposes of performing your assigned duties and for no other reason whatsoever.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Disclosure Prohibition</strong>&nbsp;<br>You shall not, during or after your employment, disclose confidential information to any third party (including friends, family, or other employees who do not require such information), except when expressly authorized in writing by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Protection of Information</strong>&nbsp;<br>You are required to protect all physical and digital confidential materials, including laptops, documents, files, emails, and communication platforms, and ensure they are not accessed, copied, or misused by any unauthorized person.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>No Copy or Retention</strong>&nbsp;<br>You shall not take, store, forward, upload, or retain any confidential information outside the Company’s authorized systems, including on personal devices, personal emails, USB drives, cloud storage, or external tools.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Post-Employment Obligations</strong>&nbsp;<br>Your confidentiality obligations remain in effect <strong>indefinitely</strong>, even after your employment ends. You must not use Company or client-related knowledge, data, or materials for any purpose outside the Company, including for self-employment or another employer.&nbsp;<br>&nbsp;</p>
<p><strong>Breach Consequences</strong>&nbsp;<br>Any breach or suspected breach of confidentiality shall be treated as serious misconduct and may result in disciplinary action, up to and including immediate termination, legal action, and claims for damages.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>16. Intellectual Property Rights</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>All work, materials, ideas, discoveries, concepts, designs, documents, analytical reports, business requirements, presentations, client deliverables, source code, scripts, software, databases, models, workflows, process documentation, or any intellectual output (“Work Product”) created, developed, contributed to, or delivered by you during the course of your employment—whether individually or as part of a team—shall be the <strong>exclusive property of Zithas Technologies Pvt. Ltd.</strong> (“the Company”).&nbsp;</p>
<p>&nbsp;</p>
<p>You acknowledge and agree that:&nbsp;</p>
<p>&nbsp;</p>
<p><strong>All Intellectual Property (IP) created during employment belongs solely to the Company</strong>, regardless of whether it was created during working hours, at the workplace, using Company resources, or otherwise.&nbsp;<br>&nbsp;</p>
<p>You shall not claim authorship, ownership, royalties, moral rights, or any intellectual rights over any Work Product.&nbsp;<br>&nbsp;</p>
<p>You shall not copy, store, retain, distribute, disclose, or use any Work Product for personal use, future employment, projects, freelancing, side work, or any purpose outside the Company.&nbsp;<br>&nbsp;</p>
<p>You shall not remove, copy, or transfer Company or client materials, prototypes, documents, source code, credentials, or any other IP from Company systems without explicit written permission.&nbsp;<br>&nbsp;</p>
<p>Upon cessation of employment, you must:&nbsp;</p>
<p>Immediately return or delete all Work Product, including physical and digital copies.&nbsp;</p>
<p>Surrender all project materials, analysis documents, research notes, and credentials.&nbsp;</p>
<p>Certify in writing that no Company IP remains in your possession or devices.&nbsp;<br>&nbsp;</p>
<p>Any unauthorized use, sharing, reproduction, or retention of Company IP shall be treated as a <strong>serious breach of contract</strong>, and the Company reserves the right to pursue disciplinary, civil, and criminal action as applicable.&nbsp;</p>
<p>&nbsp;</p>
<p>This obligation shall <strong>survive the termination</strong> of your employment, without limitation.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>17. Moonlighting &amp; Conflict of Interest</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>You shall not engage in any form of secondary employment, freelance work, consultancy, business activity, partnership, or any other professional engagement, whether paid or unpaid, without the prior written approval of the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>For clarity, the following shall be considered <strong>Moonlighting</strong> or a <strong>Conflict of Interest</strong>:&nbsp;</p>
<p>&nbsp;</p>
<p>a) <strong>Working for another employer</strong>, business, or client during or outside Company working hours.&nbsp;</p>
<p>b) <strong>Freelancing or contract work</strong>, including software development, design, consulting, or technical services.&nbsp;</p>
<p>c) <strong>Running or participating in any business</strong>, startup, or commercial activity that competes with or affects your duties.&nbsp;</p>
<p>d) <strong>Engaging with Company clients</strong>, past clients, or prospects for personal gain or independent work.&nbsp;</p>
<p>e) <strong>Using Company time, resources, information, or intellectual property</strong> for non-Company purposes.&nbsp;</p>
<p>f) <strong>Any activity that affects performance</strong>, attendance, focus, or professionalism in your role.&nbsp;</p>
<p>g) <strong>Any arrangement that compromises confidentiality</strong>, data security, or loyalty to the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>If you wish to participate in any external activity of a professional nature (including teaching, mentoring, content creation, or events), you must obtain prior written approval from the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>A breach of this Clause shall constitute misconduct and may result in disciplinary action, including termination of employment without notice.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>18. Data Protection &amp; Cybersecurity</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall comply with all data protection, information security, and cybersecurity policies of the Company, as amended from time to time. Owing to the sensitive nature of software development, client operations, and proprietary information, strict adherence to data security protocols is mandatory at all times.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>a) Confidential Data Handling</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall handle all Company and client data—whether in electronic, written, verbal, or any other form—with the highest degree of confidentiality and security.&nbsp;</p>
<p>This includes source code, documentation, designs, client records, access credentials, project information, and any other sensitive or restricted material.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>b) Authorized Use Only</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Company systems, tools, software, platforms, devices, and access credentials must be used <strong>solely for official business purposes</strong>.&nbsp;</p>
<p>The Employee shall not:&nbsp;</p>
<p>access data not related to their role,&nbsp;</p>
<p>bypass or disable any security controls,&nbsp;</p>
<p>install unauthorized software,&nbsp;</p>
<p>misuse internet or communication systems, or&nbsp;</p>
<p>share access credentials with any person inside or outside the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>c) Device Security Requirements</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Whether using Company-provided devices or approved personal devices under the Company’s BYOD policy, the Employee must ensure that such devices:&nbsp;</p>
<p>are password-protected,&nbsp;</p>
<p>have updated antivirus/antimalware protection,&nbsp;</p>
<p>meet all Company security standards, and&nbsp;</p>
<p>are not used for storing personal or unauthorized data.&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall immediately report any loss, damage, or suspected compromise of devices or data.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>d) Data Transfer &amp; Storage Restrictions</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall not copy, email, download, upload, print, store, or transfer Company or client data on any personal device, personal cloud storage, external media, or unapproved platform.&nbsp;</p>
<p>All data must only be stored on Company-approved systems, repositories, or cloud environments.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>e) Reporting Obligations</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee must promptly report any security breach, unauthorized access, suspicious activity, or data incident to the Management or IT Security Team.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>f) Post-Employment Obligations</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>All data protection and cybersecurity obligations shall continue to apply <strong>even after termination of employment</strong>, irrespective of the reason for separation.&nbsp;</p>
<p>&nbsp;</p>
<p>Any breach of this clause, intentional or otherwise, may lead to disciplinary action, including termination, legal action, and financial liability for damages caused to the Company or its clients.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>19. Remote Work &amp; BYOD (Bring Your Own Device)</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee may be permitted to work remotely (Work From Home) on a temporary or periodic basis, subject to prior approval of the Company. Remote work is a privilege and not an entitlement, and may be modified or withdrawn at any time based on operational requirements, performance concerns, or security considerations.&nbsp;</p>
<p>&nbsp;</p>
<p>When working remotely, the Employee must ensure:&nbsp;</p>
<p>&nbsp;</p>
<p>a) <strong>Productivity &amp; Availability</strong>&nbsp;</p>
<p>The Employee shall remain fully reachable during working hours and maintain performance, responsiveness, and accountability at the same standard expected during on-site work.&nbsp;</p>
<p>&nbsp;</p>
<p>b) <strong>Data Security &amp; Confidentiality</strong>&nbsp;</p>
<p>All Company information, client data, passwords, source code, documents, and systems accessed during remote work must be protected with strict confidentiality. The Employee must ensure secure internet connectivity, avoid public networks, and prevent unauthorized access by any third party.&nbsp;</p>
<p>&nbsp;</p>
<p>c) <strong>Use of Personal Devices (BYOD)</strong>&nbsp;</p>
<p>If the Employee uses personal devices (laptop, mobile, storage device, etc.) for Company work:&nbsp;</p>
<p>such devices must be protected with passwords and updated security measures,&nbsp;</p>
<p>Company-approved tools, software, and security controls must be installed when required,&nbsp;</p>
<p>Company data must not be stored permanently on any personal device, and&nbsp;</p>
<p>all files, credentials, and Company materials must be removed from personal devices upon request or upon separation.&nbsp;</p>
<p>&nbsp;</p>
<p>d) <strong>Restriction on External Storage &amp; Transfers</strong>&nbsp;</p>
<p>The Employee shall not transfer Company data to any unapproved storage medium, cloud service, email, or messaging platform. Use of USB drives, personal email, or third-party storage services is strictly prohibited unless formally approved by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>e) <strong>Return of Data &amp; Access Rights</strong>&nbsp;</p>
<p>Upon termination of remote work arrangements or upon separation, the Employee must immediately delete all Company data from personal devices and assist in verifying compliance with Company-offboarding protocols.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>20. Code of Conduct, Misconduct &amp; Disciplinary Action</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>You are expected to conduct yourself in a professional, ethical, and responsible manner at all times during your employment with the Company. You shall comply with all Company policies, codes of conduct, workplace rules, and applicable laws, including policies relating to workplace behaviour, information security, confidentiality, anti-harassment, and professional integrity.&nbsp;</p>
<p>&nbsp;</p>
<p>Any act of misconduct, including but not limited to dishonesty, negligence, insubordination, unauthorised absence, misuse of Company resources, breach of confidentiality, data misuse, harassment, conflict of interest, or violation of Company policies, shall be treated as a serious breach of employment obligations. In such cases, the Company may initiate disciplinary action based on the nature and severity of the misconduct.&nbsp;</p>
<p>&nbsp;</p>
<p>Disciplinary action may include verbal or written warnings, suspension, extension of notice period, or termination of employment. In cases of serious misconduct, the Company reserves the right to terminate employment with immediate effect, without notice or compensation, in accordance with applicable laws.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>21. Restrictive Covenant (Non-Solicitation)</strong>&nbsp;</p>
<p>During the course of your employment and for a period of <strong>twelve (12) months</strong> following the cessation of your employment for any reason, you shall not, directly or indirectly, solicit, induce, or attempt to solicit or induce any client, customer, vendor, consultant, or business associate of the Company with whom you had professional dealings during your employment, for the purpose of providing competing services or diverting business away from the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>You further agree that during the same period, you shall not solicit, encourage, or induce any employee, contractor, or consultant of the Company to resign, disengage, or join any competing organization. This restriction is intended to protect the Company’s legitimate business interests, goodwill, confidential information, and workforce, and shall apply irrespective of the reason for termination of employment.&nbsp;</p>
<p>&nbsp;</p>
<p>This clause shall survive the termination of your employment and shall remain enforceable to the extent permitted under applicable Indian law.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>22. Indemnity</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>You agree to indemnify, defend, and hold harmless <strong>Zithas Technologies Pvt. Ltd.</strong>, its directors, officers, employees, and clients from and against any losses, damages, liabilities, penalties, costs, or expenses (including reasonable legal fees) arising out of or in connection with your willful misconduct, negligence, breach of this Appointment Letter, violation of Company policies, breach of confidentiality, intellectual property infringement, misuse of Company or client data, or any unauthorized or unlawful act committed by you during the course of your employment.&nbsp;</p>
<p>&nbsp;</p>
<p>This obligation shall survive the termination or cessation of your employment with the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>23. Change to Terms of Employment</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>The Company reserves the right to amend, modify, or update the terms and conditions of this Appointment Letter, including Company policies, procedures, and rules, in order to comply with business requirements, operational needs, or changes in applicable laws. Any such changes shall be communicated to the Employee through written notice, email, or publication on the Company’s internal systems, and shall become effective from the date specified by the Company. Continued employment after such communication shall constitute acceptance of the revised terms.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>24. Severability</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>If any provision of this Appointment Letter is held to be invalid, unlawful, or unenforceable by a court or competent authority, such provision shall be severed from this Appointment Letter, and the remaining provisions shall continue to remain valid, binding, and enforceable to the fullest extent permitted by law.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>25. Digital Media &amp; Company Representation</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>During the course of employment, the Company may capture photographs, videos, or other digital media content in which the Employee may appear, for internal communication, training, documentation, branding, or promotional purposes. By accepting this appointment, the Employee provides consent to the Company to use such content solely for lawful and professional business purposes, provided that such usage does not adversely affect the Employee’s dignity, privacy, or reputation.&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall not publish, share, or circulate any false, misleading, defamatory, or harmful statements, images, or content relating to the Company, its management, employees, clients, or business activities on social media platforms, professional networks, or any public forum, during or after the period of employment. Any violation of this clause may result in disciplinary action and/or legal proceedings, as deemed appropriate by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>26. Return of Intellectual Property &amp; Access Rights</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Upon resignation, termination, or cessation of employment for any reason, the Employee shall immediately return to the Company all intellectual property, data, documents, records, source code, designs, files, client information, credentials, and any other materials belonging to the Company or its clients, whether in physical or electronic form.&nbsp;</p>
<p>&nbsp;</p>
<p>The Employee shall not retain, copy, transfer, store, or use any Company or client information after separation, nor attempt to access Company systems, platforms, or resources once access rights are withdrawn. This obligation applies irrespective of whether the information was created, accessed, or stored during the course of employment.&nbsp;</p>
<p>&nbsp;</p>
<p>Failure to comply with this clause may result in the Company withholding relieving documents and taking appropriate disciplinary or legal action, in addition to any other remedies available under law.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>27. Non-Disparagement</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>During the course of employment and after separation from the Company, the Employee shall not make, publish, or communicate any false, misleading, or disparaging statements—whether verbally, in writing, or through digital or social media—about the Company, its directors, employees, clients, services, or business practices.&nbsp;</p>
<p>&nbsp;</p>
<p>This clause does not restrict the Employee from expressing lawful opinions or reporting concerns through appropriate legal or regulatory channels. Any violation of this clause may result in disciplinary or legal action as deemed appropriate by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>28. Background Verification &amp; False Information</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>Your appointment and continuation of employment with the Company are subject to the successful verification of all information provided by you, including but not limited to your identity, educational qualifications, employment history, experience, skills, compensation details, and any other information deemed relevant by the Company.&nbsp;</p>
<p>&nbsp;</p>
<p>If, at any time during the course of your employment, it is found that any information, declaration, or document furnished by you is false, misleading, incomplete, or suppressed, the Company reserves the right to take appropriate action, including <strong>immediate termination of employment without notice or compensation</strong>.&nbsp;</p>
<p>&nbsp;</p>
<p>In such cases, the Employee shall not be entitled to any relieving letter, experience certificate, or other employment-related documentation, and the Company shall not be liable for any claims arising out of such termination.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>29. Arbitration &amp; Governing Law</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>This Appointment Letter and the employment relationship between the Company and the Employee shall be governed by and construed in accordance with the <strong>laws of India</strong>.&nbsp;</p>
<p>&nbsp;</p>
<p>Any dispute, difference, or claim arising out of or in connection with this Appointment Letter, your employment, or termination thereof shall first be attempted to be resolved amicably. If such dispute is not resolved, it shall be referred to and finally resolved by <strong>arbitration</strong> in accordance with the provisions of the <strong>Arbitration and Conciliation Act, 1996</strong>.&nbsp;</p>
<p>&nbsp;</p>
<p>The <strong>seat and venue of arbitration shall be Vadodara, Gujarat, India</strong>, and the arbitration proceedings shall be conducted in the English language. The courts at <strong>Vadodara, Gujarat, India</strong> shall have exclusive jurisdiction over all matters arising out of this Appointment Letter.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>30. Acknowledgment &amp; Acceptance</strong>&nbsp;</p>
<p>By signing this Appointment Letter, you confirm that you have read, understood, and accepted all the terms and conditions of employment contained herein, including all clauses and annexures forming part of this letter. You agree to abide by the Company’s policies, rules, and procedures as amended from time to time.&nbsp;</p>
<p>&nbsp;</p>
<p>This Appointment Letter, together with its annexures, constitutes the entire agreement between you and the Company and supersedes any prior discussions, representations, or understandings, whether written or oral.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Accepted and Agreed</strong>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Employee Name:</strong> __________________________&nbsp;</p>
<p><strong>Signature:</strong> ______________________________&nbsp;</p>
<p><strong>Date:</strong> _________________________________&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>For Zithas Technologies Pvt. Ltd.</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>______________________________</strong>&nbsp;</p>
<p><strong>Yesha Makwana</strong>&nbsp;</p>
<p><strong>Operations Director&nbsp;</strong>&nbsp;</p>
<p>Zithas Technologies Pvt. Ltd.&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>ANNEXURE A</strong> - <strong>EMPLOYEE DETAILS</strong>&nbsp;</p>
<p>&nbsp;</p>
<figure class="table">
    <table>
        <tbody>
            <tr>
                <td><strong>Particulars</strong>&nbsp;</td>
                <td><strong>Details</strong>&nbsp;</td>
            </tr>
            <tr>
                <td>Employee Name&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Designation&nbsp;</td>
                <td>Business Analyst&nbsp;</td>
            </tr>
            <tr>
                <td>Date of Joining&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Employee ID&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Department&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Reporting Manager&nbsp;</td>
                <td>&nbsp;</td>
            </tr>
            <tr>
                <td>Primary Work Location&nbsp;</td>
                <td>Vadodara, Gujarat&nbsp;</td>
            </tr>
            <tr>
                <td>Employment Type&nbsp;</td>
                <td>Full-Time&nbsp;</td>
            </tr>
            <tr>
                <td>Contract Period&nbsp;</td>
                <td>Two (2) Years&nbsp;</td>
            </tr>
            <tr>
                <td>Notice Period&nbsp;</td>
                <td>Four (4) Months&nbsp;</td>
            </tr>
        </tbody>
    </table>
</figure>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>ANNEXURE B – COMPENSATION STRUCTURE</strong>&nbsp;</p>
<p>&nbsp;</p>
<figure class="table">
    <table>
        <tbody>
            <tr>
                <td><strong>Salary Components</strong>&nbsp;</td>
                <td><strong>Monthly Amount (INR)</strong>&nbsp;</td>
            </tr>
            <tr>
                <td>Basic Salary&nbsp;</td>
                <td>₹&nbsp;&nbsp;</td>
            </tr>
            <tr>
                <td>House Rent Allowance (HRA)&nbsp;</td>
                <td>₹&nbsp;&nbsp;</td>
            </tr>
            <tr>
                <td>Dearness Allowance (DA)&nbsp;</td>
                <td>₹&nbsp;&nbsp;</td>
            </tr>
            <tr>
                <td>Conveyance Allowance&nbsp;</td>
                <td>₹&nbsp;&nbsp;</td>
            </tr>
            <tr>
                <td><strong>Gross Monthly Salary</strong>&nbsp;</td>
                <td><strong>₹&nbsp;</strong>&nbsp;</td>
            </tr>
            <tr>
                <td><strong>Deductions</strong>&nbsp;</td>
                <td><strong>Monthly Amount (INR)</strong>&nbsp;</td>
            </tr>
            <tr>
                <td>Professional Tax&nbsp;</td>
                <td>₹ 200&nbsp;</td>
            </tr>
            <tr>
                <td><strong>Total Deductions</strong>&nbsp;</td>
                <td><strong>₹ 200</strong>&nbsp;</td>
            </tr>
            <tr>
                <td>
                    <p><strong>Net Monthly Salary Payable</strong>&nbsp;</p>
                    <p><strong>(Gross Monthly Salary – Deductions)</strong>&nbsp;</p>
                </td>
                <td><strong>₹&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>&nbsp;</td>
            </tr>
        </tbody>
    </table>
</figure>
<p>&nbsp;</p>
<p><strong>Notes:</strong>&nbsp;</p>
<p>Salary shall be paid monthly, subject to attendance and Company policies.&nbsp;</p>
<p>Professional Tax is deducted as per applicable State laws.&nbsp;</p>
<p>Statutory deductions such as Provident Fund (PF) and ESIC shall be applicable if and when implemented as per Indian law.&nbsp;</p>
<p>The Company reserves the right to revise salary components in compliance with statutory or policy changes, without reducing the total fixed gross salary unless required by law.&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Declaration</strong>&nbsp;</p>
<p>&nbsp;</p>
<p>I confirm that the above details are true and correct to the best of my knowledge and form an integral part of my Appointment Letter.&nbsp;</p>
<p>&nbsp;</p>
<p><strong>Employee Signature:</strong> ____________________&nbsp;</p>
<p><strong>Name:</strong> _________________________________&nbsp;</p>
<p><strong>Date:</strong> _________________________________&nbsp;</p>
<p>&nbsp;</p><br>`



export default dummyReportData